// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2tuSJ","buttons":"Footer_buttons___dp_E"};